import apiClient from './client';

export interface SystemSetting {
  id: string;
  key: string;
  value: string;
  category?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertSettingData {
  key: string;
  value: string;
  category?: string;
  isActive?: boolean;
}

export const systemSettingsApi = {
  getAllSettings: () => {
    return apiClient.get('/system-settings');
  },

  getSettingByKey: (key: string) => {
    return apiClient.get(`/system-settings/${key}`);
  },

  upsertSetting: (data: UpsertSettingData) => {
    return apiClient.put('/system-settings', data);
  },

  deleteSetting: (key: string) => {
    return apiClient.delete(`/system-settings/${key}`);
  },

  initializeSettings: () => {
    return apiClient.post('/system-settings/initialize');
  },
};
